import { render } from "./CostsResults.vue?vue&type=template&id=7e8e5112"
import script from "./CostsResults.vue?vue&type=script&setup=true&lang=js"
export * from "./CostsResults.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Results/CostsResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e8e5112"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e8e5112', __exports__)) {
    api.reload('7e8e5112', __exports__)
  }
  
  module.hot.accept("./CostsResults.vue?vue&type=template&id=7e8e5112", () => {
    api.rerender('7e8e5112', render)
  })

}


export default __exports__